// extracted by mini-css-extract-plugin
module.exports = {"landingPagesContext":"PropertyPortal_landingPagesContext__3tcVO","pageHeader":"PropertyPortal_pageHeader__2ratQ"};